import gauges from './gauges.json'

const gaugesAddresses = gauges.map((item) => item.gauge.toLowerCase())
const bribeAddresses = gauges.map((item) => item.bribe.toLowerCase())

export { gauges, gaugesAddresses, bribeAddresses }
